export class CoreConnectionProperties {
    hostname: string;
    port: number;
}
